const API_URL = process.env.REACT_APP_PROMPTS_API_URL;

async function updatePromptsInService() {
  try {
    const response = await fetch(API_URL, {
      method: 'GET',
    });

    // Check if status code is 200
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error calling the API:', error);
    return false;
  }
}

export default updatePromptsInService;
